import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "../shared/type";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardGrey: React.FC<Props> = ({ props }) => {
  return (
    <>
      {props.map((item, key) => {
        const params = new URLSearchParams({
          id: String(item.id),
          category: item.category,
          slug: item.urlinform,
        });
        return (
          <div key={key} className="w-full border-b pb-4 md:pb-8 max-w-[95%]">
            <Link
              target="_top"
              // to={{
              //   pathname: `/article`,
              //   // search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
              //   search: params.toString(),
              // }}
              to={`/article/${item.urlinform}`}
              key={key}
              className="text-[#1a0dab] text-[22px] font-bold"
            >
              {item.title}
            </Link>

            <div className="flex gap-2 w-full justify-between">
              <span className="text-[#4d5156] text-sm md:w-[calc(100%-104px-156px)]">
                {item.description}
              </span>
              <div className="w-[104px] h-[104px] rounded-lg overflow-hidden shadow-md border-[1px] flex-shrink-0">
                <LazyImage
                  src={item.images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CardGrey;
